// src/LoginForm.js
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import apiUrl from "../../services/environment"
import Logo from "../../assets/images/logo.svg"
import { useMenu } from "../../context/MenuContext";
import {Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
import packageJson from '../../../package.json';
// import Cookies from 'js-cookie';
const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(""); 
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();
  const { updateAuthStatus } = useMenu();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    // Simple validation for username and password
    if (!username || !password) {
      setError('Username and Password are required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Send credentials to the API for authentication
      const response = await fetch(apiUrl + "auth/login", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });

      const data = await response.json();
      if(data.status.code===200){
        toast.success(data.status.message);
        //setSuccessMessage(data.status.message);
      }else{
          toast.error(data.status.message);
      }

      if (!response.ok) {
        // If login fails, show the error message from the API
        setLoading(false);
        return;
      }

      // Assuming the API returns an object with a token like: { token: 'your_token_here' }
      const refreshToken = data.data.refreshToken;
      const accessToken = data.data.accessToken;
      const tfaEnabled = data.data.tfaEnabled;
      const passwordUpdated = data.data.passwordUpdated;
      const nextRetryOtpTime = data.data.nextRetryOtpTime;
      //const passwordUpdated = false;
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('tfaEnabled', tfaEnabled);
        localStorage.setItem('userEmail', username);
        localStorage.setItem('passwordUpdated', passwordUpdated);
        localStorage.setItem("justLoggedIn", "true");
        localStorage.setItem("nextRetryOtpTime", nextRetryOtpTime);
        updateAuthStatus(true);
        if (refreshToken != null) {
          localStorage.setItem("refreshToken", refreshToken);
         // Cookies.set('refreshToken', refreshToken); 
        }
        
        if (tfaEnabled) {
          localStorage.removeItem("otpVerified"); // Ensure fresh OTP verification is needed
          //Cookies.remove('otpVerified');
          
          history.push("/otp");
          //localStorage.setItem("passwordVerified", "true");
        }else if (tfaEnabled===false && passwordUpdated === false) { // Use 'else if' instead of 'elseIf'
          localStorage.setItem("otpVerified", "true");
          localStorage.setItem("passwordVerified", "true");
         // localStorage.setItem("passwordVerified", "true");
          history.push("/changepassword"); // Redirect to change password page
        }else {
          localStorage.setItem("otpVerified", "true"); // Mark OTP as verified if 2FA is off
          //Cookies.set('otpVerified', "true"); 
          history.push("/dashboard");
        }
      }
      

      // Clear form fields after successful login
      setUsername('');
      setPassword('');
      setLoading(false);

    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }finally {
      setLoading(false);
    }
  };
//console.log(apiUrl,"apiUrl")
  return (
    <>
    {loading && <Loader />} 
    <div className='login-wrapper'>
      <div className="login-form">
        
        <div className='login-left'>
            <img src={Logo} alt=""/>
        </div>
        <div className='login-right'>
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className='pos-relative'>
              <label htmlFor="password">Password:</label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <a className='see-password' onClick={() => setShowPassword((prev) => !prev)}> {showPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <div>
              <Link to="/reset-password" className='btn-link'>Reset Password</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <p className='version-text'>Version: {packageJson.version}</p>
    </>
  );
};

export default LoginForm;
